$(function(){

    $(window).trigger('resize');

    $("#NavDrawer .listmenu .dropMenu").click(function() {
        $(this).toggleClass('change');
        $(this).next(".subMenu").slideToggle(300);
    });

    if ($('header .specialMsg').length) {
        $('body').addClass('hasBanner'); 
    }

    ajaxCart.init({
        formSelector: '#AddToCartForm',
        cartContainer: '#CartContainer',
        addToCartSelector: '#AddToCart',
        cartCountSelector: '#CartCount',
        cartCostSelector: '#CartCost',
        moneyFormat: window.shopMoneyFormat
    });

    var headerOffset = $('header .header').offset().top;
    $(window).scroll(function () {
        if ($(window).scrollTop() > headerOffset) {
            $('body').addClass('stickyHeader');
            $('header .header').addClass('activeSticky');
        } else {
            $('body').removeClass('stickyHeader');
            $('header .header').removeClass('activeSticky');
        }
    });

    // 2026 NEW CURRENCY SELECTOR
    document.querySelectorAll('[data-currency-dropdown]').forEach(function (root) {
        var toggle = root.querySelector('[data-toggle]');
        var input = root.querySelector('[data-country-input]');
        var items = Array.prototype.slice.call(root.querySelectorAll('.currency-dropdown__item'));

        function open() {
            root.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            var sel = root.querySelector('.currency-dropdown__item.is-selected') || items[0];
            if (sel) sel.focus();
        }
        function close() {
            root.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            root.classList.contains('is-open') ? close() : open();
        });

        items.forEach(function (item) {
            item.setAttribute('tabindex', '-1');
            item.addEventListener('click', function () {
                if (item.getAttribute('data-disabled')) return;
                input.value = item.getAttribute('data-country');
                input.form.submit();
            });
            item.addEventListener('keydown', function (e) {
                var idx = items.indexOf(item);
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    item.click();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    (items[idx + 1] || items[0]).focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    (items[idx - 1] || items[items.length - 1]).focus();
                } else if (e.key === 'Escape') {
                    close();
                    toggle.focus();
                }
            });
        });

        document.addEventListener('click', function (e) {
            if (!root.contains(e.target)) close();
        });
    });

    // Smooth scroll for in-page anchors
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('.accordion-section-title')
    .not('.glightbox')
    .on('click', function(event) {
        if (this.hash !== "") {
            var hash = this.hash;
            var $scrollToPosition = $(hash).offset().top - $('header .header').height();
            $('html, body').animate({
                scrollTop: $scrollToPosition
            }, 400, function() {
                if (history.pushState) {
                    history.pushState(null, null, hash);
                } else {
                    window.location.hash = hash;
                }
            });
            return false;
        }
    }); 
    
});

$(window).on('load', function() {
    $('body').addClass('loaded');
});

jQuery('body').on('ajaxCart.afterCartLoad', function(evt, cart) {
    timber.RightDrawer.open();
});

// Megamenus (DS)
document.addEventListener('DOMContentLoaded', () => {
    const megaMenus = document.querySelectorAll('.megaMenu');
    const handleHoverIn = function () {
        const megaDrop = this.querySelector('.megaDrop');
        this.classList.add('open');
        if (megaDrop) {
            megaDrop.style.display = 'block';
            setTimeout(() => megaDrop.style.opacity = '1', 50);
        }
    };
    const handleHoverOut = function () {
        const megaDrop = this.querySelector('.megaDrop');
        this.classList.remove('open');
        if (megaDrop) {
            megaDrop.style.opacity = '0';
            this.style.pointerEvents = 'none';
            setTimeout(() => {
                megaDrop.style.display = 'none';
                this.style.pointerEvents = 'auto';
            }, 300);
        }
    };
    megaMenus.forEach((menuItem) => {
        menuItem.addEventListener('mouseenter', handleHoverIn);
        menuItem.addEventListener('mouseleave', handleHoverOut);
    });
});

// UPSELLS — modal + drawer cart click handlers
// Lives in global because the drawer cart can render on any page
if (window.upsellsEnabled) {

    document.addEventListener('click', function(event) {
        if (
            !event.target.closest('.learn-more') &&
            !event.target.closest('.modal-close') &&
            !event.target.closest('.js-addon-atc-btn')
        ) return;
        // clicked on modal trigger
        if (!!event.target.closest('.learn-more')) {
            openModal(event.target.closest('.learn-more').dataset.modalId);
        }
        // clicked on modal close button
        if (!!event.target.closest('.modal-close')) {
            closeAllModals();
        }
        // clicked on upsell add to cart button in drawer cart
        if (!!event.target.closest('.js-addon-atc-btn')) {
            event.preventDefault();
            const button = event.target.closest('.js-addon-atc-btn');
            ajaxCart.quickAdd(button.dataset.upsellVariantId, button.dataset.parentVariantId, button.dataset.parentProductId, button.dataset.addOnDiscount);
        }
    });
    window.addEventListener('click', windowOnClickUpsells);

    function openModal(modalId) {
        if (!!document.querySelector(`.upsell-modal[data-modal-id="${modalId}"`)) {
            document.querySelector(`.upsell-modal[data-modal-id="${modalId}"`).classList.toggle('show-modal');
        }
    }
    function windowOnClickUpsells(event) {
        if (!event.target.closest('.modal-inner') && !event.target.closest('.learn-more')) {
            closeAllModals();
        }
    }
    function closeAllModals() {
        document.querySelectorAll('.upsell-modal').forEach(function(m) {
            m.classList.remove('show-modal');
        });
    }

}